
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listingDetail",
      function () {
        return require("private-next-pages/listingDetail.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listingDetail"])
      });
    }
  